import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	collapsePanelLabel: {
		id: 'insight-shared-ui.collapsible-group.collapse-panel-label',
		defaultMessage: 'Collapse {title} panel',
		description: 'Aria label for the collapse icon in the collapsible panel',
	},
	expandPanelLabel: {
		id: 'insight-shared-ui.collapsible-group.expand-panel-label',
		defaultMessage: 'Expand {title} panel',
		description: 'Aria label for the expand icon in the collapsible panel',
	},
});
